import React from 'react';
import { StyleSheet, View } from 'react-native';
import ContentLoader, { Rect } from 'react-content-loader/native';
import { useTheme } from '@/context/ThemeContext';
import useResponsiveness from '@/hooks/useResponsiveness';

export default function SidebarListItemPlaceholder() {
  const { colors } = useTheme();
  const { isXS } = useResponsiveness();

  const height = isXS ? 38 : 26;

  const styles = StyleSheet.create({
    wrapper: {
      flexDirection: 'row',
      height: height,
      marginBottom: 0,
      paddingLeft: 5,
      width: '100%',
    },
  });

  return (
    <View style={styles.wrapper}>
      <ContentLoader
        speed={2}
        width={380}
        height={height}
        viewBox={`0 0 380 ${height}`}
        backgroundColor={colors.solid_color_tertiary}
        foregroundColor={colors.border_color_secondary}
      >
        <Rect x="0" y="0" rx="4" ry="4" width="380" height={height} />
      </ContentLoader>
    </View>
  );
}
